import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChildFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '../services/login.service';

@Injectable({
  providedIn: 'root'
})
 class RoleGuard  {
  constructor(private loginService: LoginService, private router: Router) {
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot):boolean {
     
      if (route.data['role'].includes(this.loginService.Role)) {

        return true;
      }
  
      // navigate to not found page
      this.router.navigate(['/PageNotFound']);
      return false;
  }
  
}
export const IRoleGuard:CanActivateChildFn=(route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot): boolean=>{
    return inject(RoleGuard).canActivate(route,state);
  }
